import SaveMedicieBody from "components/ClinicalManagement/Medicines/SaveMedicine/SaveMedicieBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const SaveMedicine = () => {
  useEffect(() => {
    document.title = "Save Medicine";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <SaveMedicieBody />
    </main>
  );
};

export default SaveMedicine;
